/**
 * Roller/Cover device template
 * Used by: Pro 2PM, Plus 2PM (in roller mode)
 *
 * Controls roller shutters, blinds, curtains, garage doors
 */

import {
	createCoverOpenAction,
	createCoverCloseAction,
	createCoverStopAction,
	createCoverGoToPositionAction,
	createCoverStateCondition,
	createCoverPositionCondition,
	createCoverStateChangedTrigger,
} from '../../common/rollerControl.js';
import { createPowerLevelCondition } from '../../common/powerMonitoring.js';

export function createRollerTemplate() {
	return {
		deviceType: 'roller',
		channels: ['cover:0'],
		actions: {
			open: createCoverOpenAction(),
			close: createCoverCloseAction(),
			stop: createCoverStopAction(),
			goToPosition: createCoverGoToPositionAction(), // requires calibration
		},
		conditions: {
			coverState: createCoverStateCondition(),
			coverPosition: createCoverPositionCondition(), // requires calibration
			powerLevel: createPowerLevelCondition(3680),
		},
		triggers: {
			stateChanged: createCoverStateChangedTrigger(),
		},
	};
}
